import styled from 'styled-components';

// ═══════════════════════════════════════════════════════════════════
// Estilos del bloque «carreteras + un rango de PK por carretera».
//
// Vivían en `UbicacioTab/styles.ts` y se mueven aquí al extraer el bloque a
// componente compartido (plantillas de recorrido, 2026-08-16). `UbicacioTab`
// los REEXPORTA desde su propio `styles.ts`, así que sigue habiendo una sola
// definición y sus imports no cambian.
// ═══════════════════════════════════════════════════════════════════

export const FormField = styled.div`
  flex: 1;
  min-width: 15rem;
`;

export const PKRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.l};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;
